<img [ngSrc]="IMAGES.LOGOS.ICEPORTAL_CONTENT_LOGO_HORIZONTAL_SVG" alt="IcePortal Content Logo" width="322" height="40" priority />
